<template>
  <v-tabs
    icons-and-text
    background-color="white"
    class="elevation-2"
    dense
    tile
    show-arrows
    next-icon="mdi-arrow-right-bold-box-outline"
    prev-icon="mdi-arrow-left-bold-box-outline"
  >
    <v-tabs-slider color="accent"></v-tabs-slider>

    <v-tab
      :to="{ name: 'instantTransfers.offers.index', params: { id: feeConfiguration.id } }"
      exact
    >
      Offers
      <v-icon>mdi-cash</v-icon>
    </v-tab>

    <v-tab
      :to="{ name: 'instantTransfers.payinmethods.index', params: { id: feeConfiguration.id } }"
      exact
    >
      PayIn Methods
      <v-icon>mdi-face-agent</v-icon>
    </v-tab>
    <v-tab
      :to="{ name: 'instantTransfers.countrymappings.index', params: { id: feeConfiguration.id } }"
    >
      Countries Mapping
      <v-icon>mdi-map-marker-multiple</v-icon>
    </v-tab>
    <v-tab
      :to="{ name: 'instantTransfers.countries.index', params: { id: feeConfiguration.id } }"
      exact
    >
      Countries
      <v-icon>mdi-map-check</v-icon>
    </v-tab>
  </v-tabs>
</template>
<script>
export default {
  data() {
    return {
      feeConfiguration: {},
    };
  },
  mounted() {
    this.$http
      .get("/api/v1/transactions/feeConfigurations/transfer")
      .then((data) => (this.feeConfiguration = data));
  },
};
</script>
